import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Вагоны';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h3>Вагон 4-осный</h3>
                    <p>4-ох осный крытый грузовой №210-0009</p>
                    <p>Изготовлен в 1936 году</p>
                    <p>Грузоподъемность - 62т</p>
                    <p>Полезный объем - 106м3</p>
                    <p>Тара - 22,7т</p>
                </div>
                <div className="three-col-cell gallery"><img src={require('./../img/virtualtours/museumlocomotive/mzt077.jpg')} /></div>
                <div className="three-col-cell gallery"><img src={require('./../img/virtualtours/museumlocomotive/mzt078.jpg')} /></div>

                <div className="pageitem">
                    <h3>Вагон 2-осный</h3>
                    <p>2-ох осный крытый грузовой №204-0000</p>
                    <p>Изготовлен в 1915 году на Коломенском машиностроительном заводе</p>
                    <p>Грузоподъемность - 20т</p>
                    <p>Полезный объем - 39м3</p>
                    <p>Тара - 11,4т</p>
                </div>
                <div className="three-col-cell gallery"><img src={require('./../img/virtualtours/museumlocomotive/mzt079.jpg')} /></div>
                <div className="three-col-cell gallery"><img src={require('./../img/virtualtours/museumlocomotive/mzt080.jpg')} /></div>

                <div className="pageitem">
                    <h3>Вагон 2-осный пасс.</h3>
                    <p>2-ох осный пассажирский жесткий №1666</p>
                    <p>Изготовлен в 1928 году на Брянском машиностроительном заводе</p>
                    <p>Кузов вагона деревянной конструкции, обшит листовым железом</p>
                    <p>Длина вагона - 14м</p>
                    <p>Количество мест для сидения -72</p>
                    <p>Тара - 22,2т</p>
                </div>
                <div className="three-col-cell gallery"><img src={require('./../img/virtualtours/museumlocomotive/mzt081.jpg')} /></div>
                <div className="three-col-cell gallery"><img src={require('./../img/virtualtours/museumlocomotive/mzt082.jpg')} /></div>
            </div>
        </>
    );
}